import { CallApi } from "app/_helpers/CallApi/CallApi";
import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
import {
  TRAINING_STATUS,
  TRAINEE_TYPE,
  TRAINING_TYPE_VIEW,
  TRAINING_STATUS_VIEW,
  TRAINING_BATCHES_STATUS_VIEW,
} from "app/_pages/_healthSafetyEnvironment/TrainingManagement/CONSTANTS.js";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import moment from "moment";
import {
  getAllOldEmployee,
  getEmployee,
  getEmployeeForOtherModuel,
} from "../UserManagement/EmployeeService";
import { getContractor } from "../Contractor/ContractorService";
import {
  getAllContractorPerson,
  getAllOldContPerson,
  getContPersonForOtherModuel,
} from "../UserManagement/ContractorPersonService";
import { capitalizeName } from "app/_helpers/helper";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
import configureStore from "../../redux/Store";
import { fil } from "date-fns/locale";
let { Store } = configureStore();
export const trainingTypes = {
  category: "Category",
  workArea: "Work Area",
  complianceCategory: "Compliance Category",
  event: "Event",
  meetingGroup: "Meeting Group",
  workPermit: "Work Permit",
};

const formattedTrainingData = (data, employeeList, contractorStaffList) => {
  const formattedData = data?.map((d, index) => {
    let objData = {};
    if (d?.traineeType === "employee") {
      objData = (employeeList?.data || [])?.find((obj) => obj?.id === d?.traineeId);
    } else if (d?.traineeType === "contractorPerson") {
      objData = (contractorStaffList?.data || [])?.find(
        (obj) => obj?.id === d?.traineeId
      );
    }
    return {
      ...d,
      sid: index + 1,
      batchName: d.batchData?.batchId,
      dueDateView: DDMMYYYYFormat(d?.dueDate),
      dueYear: +moment(d?.dueDate).format("YYYY"),
      traineeName: objData
        ? `${capitalizeName(
            (objData?.firstName || "") + " " + (objData?.lastName || "")
          )}`
        : "",
      trainingStatusView: `${TRAINING_STATUS_VIEW[d.trainingStatus]}${
        d.isAbsent && d.trainingStatus === TRAINING_STATUS.due ? " (Absent)" : ""
      }`,
      trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
      traineeTypeView: TRAINEE_TYPE[d.traineeType],
      trainingCategoryName: d.trainingCategoryData?.name,
      trainingSubCategoryName: d.trainingCategoryData?.subCategory?.find(
        (sub) => sub.id === d.trainingSubCategory
      )?.name,
      traineeID: objData ? objData?.srNo || objData?.employeeId : "",
      traineeDesignation: d.newBasicTrainingDesignationData?.name,
      formA: objData ? objData?.srNo || objData?.employeeFormA?.serialNumberOmc : "",
      contractorId: +d.traineeData?.contractorId,
      siteName: d?.ehsSite?.name,
      currentLocation: objData?.ehsSite?.name || "",
    };
  });
  return formattedData;
};

export async function getAllTrainingAssigners(filter) {
  let filterType = filter;
  const basicTrainingData = Store.getState()?.userManagement?.basicTraining;
  const newBasicTrainingData = Store.getState()?.userManagement?.newBasicTraining;
  // const trainingBatchData = Store.getState()?.userManagement?.trainingBatchDetails;
  // console.log("training batches stored", trainingBatchData);
  if (
    filter === "basicTraining" &&
    Array.isArray(basicTrainingData.data) &&
    basicTrainingData.data.length
  ) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: basicTrainingData.data,
        });
      }, 0);
    });
  }
  if (
    filter === "newBasicTraining" &&
    Array.isArray(newBasicTrainingData.data) &&
    newBasicTrainingData.data.length
  ) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: newBasicTrainingData.data,
        });
      }, 0);
    });
  }
  // if (
  //   filter === "all-training-batches" &&
  //   Array.isArray(trainingBatchData.data) &&
  //   trainingBatchData.data.length
  // ) {
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve({
  //         status: 1,
  //         message: "Data from store",
  //         data: trainingBatchData.data,
  //       });
  //     }, 0);
  //   });
  // }
  let url =
    "/global-configuration/ehs-module/all-training-assigners" +
    (filter ? `/${filter}` : "");
  const result = await CallApi(url, "GET");
  // const employeeList = await getEmployee();
  // const contractorStaffList = await getAllContractorPerson();
  const employeeList = await getEmployeeForOtherModuel();
  const contractorStaffList = await getContPersonForOtherModuel();
  const oldEmployeeList = await getAllOldEmployee();
  const oldContractorStaffList = await getAllOldContPerson();
  const { status, message, data = [] } = result;

  if (filterType === "basicTraining" && status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.BASIC_TRAINING,
      data: data?.map((d, index) => {
        let objData = {};
        if (d?.traineeType === "employee") {
          objData =
            (employeeList?.data || [])?.find((obj) => obj?.id === d?.traineeId) ||
            (oldEmployeeList?.data || [])?.find((obj) => obj?.id === d?.traineeId);
        } else if (d?.traineeType === "contractorPerson") {
          objData =
            (contractorStaffList?.data || [])?.find((obj) => obj?.id === d?.traineeId) ||
            (oldContractorStaffList?.data || [])?.find((obj) => obj?.id === d?.traineeId);
        }
        return {
          ...d,
          sid: index + 1,
          batchName: d.batchData?.batchId,
          dueDateView: DDMMYYYYFormat(d?.dueDate),
          dueYear: +moment(d?.dueDate).format("YYYY"),
          traineeName: objData
            ? `${capitalizeName(
                (objData?.firstName || "") + " " + (objData?.lastName || "")
              )}`
            : "",
          trainingStatusView: `${TRAINING_STATUS_VIEW[d.trainingStatus]}${
            d.isAbsent && d.trainingStatus === TRAINING_STATUS.due ? " (Absent)" : ""
          }`,
          trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
          traineeTypeView: TRAINEE_TYPE[d.traineeType],
          trainingCategoryName: d.trainingCategoryData?.name,
          trainingSubCategoryName: d.trainingCategoryData?.subCategory?.find(
            (sub) => sub.id === d.trainingSubCategory
          )?.name,
          traineeID: objData ? objData?.srNo || objData?.employeeId : "",
          traineeDesignation: d.newBasicTrainingDesignationData?.name,
          formA: objData ? objData?.srNo || objData?.employeeFormA?.serialNumberOmc : "",
          contractorId: +d.traineeData?.contractorId,
          siteName: d?.ehsSite?.name,
        };
      }),
    });
  }
  if (filterType === "newBasicTraining" && status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.NEW_BASIC_TRAINING,
      data: data?.map((d, index) => {
        let objData = {};
        if (d?.traineeType === "employee") {
          objData =
            (employeeList?.data || [])?.find((obj) => obj?.id === d?.traineeId) ||
            (oldEmployeeList?.data || [])?.find((obj) => obj?.id === d?.traineeId);
        } else if (d?.traineeType === "contractorPerson") {
          objData =
            (contractorStaffList?.data || [])?.find((obj) => obj?.id === d?.traineeId) ||
            (oldContractorStaffList?.data || [])?.find((obj) => obj?.id === d?.traineeId);
        }
        return {
          ...d,
          sid: index + 1,
          batchName: d.batchData?.batchId,
          dueDateView: DDMMYYYYFormat(d?.dueDate),
          dueYear: +moment(d?.dueDate).format("YYYY"),
          traineeName: objData
            ? `${capitalizeName(
                (objData?.firstName || "") + " " + (objData?.lastName || "")
              )}`
            : "",
          trainingStatusView: `${TRAINING_STATUS_VIEW[d.trainingStatus]}${
            d.isAbsent && d.trainingStatus === TRAINING_STATUS.due ? " (Absent)" : ""
          }`,
          trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
          traineeTypeView: TRAINEE_TYPE[d.traineeType],
          trainingCategoryName: d.trainingCategoryData?.name,
          trainingSubCategoryName: d.trainingCategoryData?.subCategory?.find(
            (sub) => sub.id === d.trainingSubCategory
          )?.name,
          traineeID: objData ? objData?.srNo || objData?.employeeId : "",
          traineeDesignation: d.newBasicTrainingDesignationData?.name,
          formA: objData ? objData?.srNo || objData?.employeeFormA?.serialNumberOmc : "",
          contractorId: +d.traineeData?.contractorId,
          siteName: d?.ehsSite?.name,
        };
      }),
    });
  }

  // if (filterType === "all-training-batches" && status) {
  //   console.log("set all training batches");
  //   Store.dispatch({
  //     type: USER_DATA_CONSTANT.TRAINING_BATCH_DETAILS,
  //     data: data?.map((d, index) => {
  //       let objData = {};
  //       if (d?.traineeType === "employee") {
  //         objData = (employeeList?.data?.employees || [])?.find(
  //           (obj) => obj?.id === d?.traineeId
  //         );
  //       } else if (d?.traineeType === "contractorPerson") {
  //         objData = (contractorStaffList?.data || [])?.find(
  //           (obj) => obj?.id === d?.traineeId
  //         );
  //       }
  //       return {
  //         ...d,
  //         sid: index + 1,
  //         batchName: d.batchData?.batchId,
  //         dueDateView: DDMMYYYYFormat(d?.dueDate),
  //         dueYear: +moment(d?.dueDate).format("YYYY"),
  //         traineeName: objData
  //           ? `${capitalizeName(
  //               (objData?.firstName || "") + " " + (objData?.lastName || "")
  //             )}`
  //           : "",
  //         trainingStatusView: `${TRAINING_STATUS_VIEW[d.trainingStatus]}${
  //           d.isAbsent && d.trainingStatus === TRAINING_STATUS.due ? " (Absent)" : ""
  //         }`,
  //         trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
  //         traineeTypeView: TRAINEE_TYPE[d.traineeType],
  //         trainingCategoryName: d.trainingCategoryData?.name,
  //         trainingSubCategoryName: d.trainingCategoryData?.subCategory?.find(
  //           (sub) => sub.id === d.trainingSubCategory
  //         )?.name,
  //         traineeID: objData ? objData?.srNo || objData?.employeeId : "",
  //         traineeDesignation: d.newBasicTrainingDesignationData?.name,
  //         formA: objData
  //           ? objData?.contractorFormA?.serialNumberOmc ||
  //             objData?.employeeFormA?.serialNumberOmc
  //           : "",
  //         contractorId: +d.traineeData?.contractorId,
  //         siteName: d?.ehsSite?.name,
  //       };
  //     }),
  //   });
  // }

  return {
    status,
    message,
    data: data?.map((d, index) => {
      let objData = {};
      if (d?.traineeType === "employee") {
        objData =
          (employeeList?.data || [])?.find((obj) => obj?.id === d?.traineeId) ||
          (oldEmployeeList?.data || [])?.find((obj) => obj?.id === d?.traineeId);
      } else if (d?.traineeType === "contractorPerson") {
        objData =
          (contractorStaffList?.data || [])?.find((obj) => obj?.id === d?.traineeId) ||
          (oldContractorStaffList?.data || [])?.find((obj) => obj?.id === d?.traineeId);
      }
      return {
        ...d,
        sid: index + 1,
        batchName: d.batchData?.batchId,
        dueDateView: DDMMYYYYFormat(d?.dueDate),
        dueYear: +moment(d?.dueDate).format("YYYY"),
        traineeName: objData
          ? `${capitalizeName(
              (objData?.firstName || "") + " " + (objData?.lastName || "")
            )}`
          : "",
        trainingStatusView: `${TRAINING_STATUS_VIEW[d.trainingStatus]}${
          d.isAbsent && d.trainingStatus === TRAINING_STATUS.due ? " (Absent)" : ""
        }`,
        trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
        traineeTypeView: TRAINEE_TYPE[d.traineeType],
        trainingCategoryName: d.trainingCategoryData?.name,
        trainingSubCategoryName: d.trainingCategoryData?.subCategory?.find(
          (sub) => sub.id === d.trainingSubCategory
        )?.name,
        traineeID: objData ? objData?.srNo || objData?.employeeId : "",
        traineeDesignation: d.newBasicTrainingDesignationData?.name,
        formA: objData ? objData?.srNo || objData?.employeeFormA?.serialNumberOmc : "",
        contractorId: +d.traineeData?.contractorId,
        siteName: d?.ehsSite?.name,
      };
    }),
  };
}

export async function getInActiveStaffTrainingList(tabType) {
  let storeKey =
    tabType === "unAssigned" ? "trainingInActiveUnassigned" : "trainingInActiveAssigned";
  const traininglData = Store.getState()?.userManagement?.[storeKey];
  if (Array.isArray(traininglData?.data) && traininglData?.data?.length) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: traininglData.data,
        });
      }, 0);
    });
  }
  let url =
    "/global-configuration/ehs-module/all-training-inActive-staff" +
    (tabType ? `/${tabType}` : "");
  const result = await CallApi(url, "GET");
  const employeeList = await getAllOldEmployee();
  const contractorStaffList = await getAllOldContPerson();
  const { status, message, data = [] } = result;
  const filteredData = formattedTrainingData(data, employeeList, contractorStaffList);
  if (result.status && tabType === "unAssigned")
    Store.dispatch({
      type: USER_DATA_CONSTANT.TRAINING_IN_ACTIVE_UNASSIGNED,
      data: filteredData,
    });
  if (result.status && tabType === "assigned")
    Store.dispatch({
      type: USER_DATA_CONSTANT.TRAINING_IN_ACTIVE_ASSIGNED,
      data: filteredData,
    });

  return {
    status,
    message,
    data: filteredData,
  };
}

export async function getMyApprovalHistory(filter) {
  let url =
    "/global-configuration/ehs-module/login-user-training-approval-history" +
    (filter ? `?${filter}` : "");

  const result = await CallApi(url, "GET");

  const { status, message, data } = result;

  const mapFunc = (d, index) => {
    return {
      ...d,
      sid: index + 1,
      batchName: d.batchData?.batchId,
      traineeName: `${capitalizeName(
        (d.TrainingAssigneeData?.firstName || "") +
          " " +
          (d.TrainingAssigneeData?.lastName || "")
      )}`,
      trainingStatusView: `${TRAINING_STATUS_VIEW[d.trainingStatus]} ${
        d.isAbsent && d.trainingStatus === TRAINING_STATUS.due ? "(Absent)" : ""
      }`,
      trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
      traineeTypeView: TRAINEE_TYPE[d.traineeType],
      trainingCategoryName: d.trainingCategoryData?.name,
      trainingSubCategoryName: d.trainingCategoryData?.subCategory?.find(
        (sub) => sub.id === d.trainingSubCategory
      )?.name,
      traineeID: d.TrainingAssigneeData?.srNo || d.TrainingAssigneeData?.employeeId,
      traineeDesignation: d.TrainingAssigneeData?.designation,
      formA:
        d.TrainingAssigneeData?.srNo ||
        d.TrainingAssigneeData?.employeeFormA?.serialNumberOmc,
      contractorId: +d.TrainingAssigneeData?.contractorId,
    };
  };
  return {
    status,
    message,
    data: {
      minesManager: data?.minesManager?.map(mapFunc) || [],
      safetyOfficer: data?.safetyOfficer?.map(mapFunc) || [],
      vocationalTrainingOfficer:
        data?.vocationalTrainingOfficer?.map((batch, index) => {
          //console.log('batttttt', batch?.traineeList?.shift()?.ehsSite?.name)
          const traineeListArray = batch?.traineeList;
          const traineeDataObj = traineeListArray?.length && traineeListArray?.[0];
          return {
            ...batch,
            siteId: traineeDataObj?.siteId,
            siteName: traineeDataObj?.ehsSite?.name,
            batchName: batch?.batchId,
            sid: index + 1,
            trainingDateView: DDMMYYYYFormat(batch.trainingDate),
            trainingCategoryName: batch?.trainingCategoryData?.name,
            trainingCategoryId: +batch?.trainingCategory,
            count: batch?.traineeList?.length,
            areaName: batch?.area?.name,
            traineeList: batch?.traineeList?.map((d, i) => ({
              sid: i + 1,
              ...d,
              trainingStatusView: TRAINING_STATUS_VIEW[d.trainingStatus],
              trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
              traineeTypeView: TRAINEE_TYPE[d.traineeType],
              trainingCategoryName: d?.trainingCategoryData?.name,
              trainingSubCategoryName: d?.trainingCategoryData?.subCategory?.find(
                (sub) => sub.id === d?.trainingSubCategory
              )?.name,
              traineeID:
                d?.TrainingAssigneeData?.srNo || d?.TrainingAssigneeData?.employeeId,
              traineeName: `${capitalizeName(
                d?.TrainingAssigneeData?.firstName +
                  " " +
                  d?.TrainingAssigneeData?.lastName
              )}`,

              traineeDesignation:
                d?.TrainingAssigneeData?.srNo || d?.TrainingAssigneeData?.employeeId,

              centerCode: batch?.centerCode,
              centerName: batch?.centerName,
              batchId: batch?.batchId,
              duration: batch?.duration,
            })),
            trainingTypeView: TRAINING_TYPE_VIEW[traineeDataObj?.trainingType],
            batchStatusView: TRAINING_BATCHES_STATUS_VIEW[batch?.batchStatus],
          };
        }) || [],
    },
  };
}

export async function getAllTrainingBatches(filter) {
  const trainingBatchData = Store.getState()?.userManagement?.trainingBatchDetails;
  let url =
    "/global-configuration/ehs-module/all-training-batches" +
    (filter ? `?${filter}` : "");
  if (!filter && Array.isArray(trainingBatchData.data) && trainingBatchData.data.length) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: trainingBatchData.data,
        });
      }, 0);
    });
  }
  const result = await CallApi(url, "GET");
  const { status, message, data = [] } = result;
  if (!filter && status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.TRAINING_BATCH_DETAILS,
      data: data?.map((batch, index) => {
        const traineeListArray = batch?.traineeList;
        const traineeDataObj = traineeListArray?.length && traineeListArray?.[0];
        return {
          ...batch,
          sid: index + 1,
          batchName: batch?.batchId,
          trainingDateView: DDMMYYYYFormat(batch.trainingDate),
          trainingCategoryName: batch?.trainingCategoryData?.name,
          trainingCategoryId: +batch?.trainingCategory,
          count: batch?.traineeList?.length,
          areaName: batch?.area?.name,
          traineeList: batch?.traineeList?.map((d, i) => ({
            sid: i + 1,
            ...d,
            trainingStatusView: TRAINING_STATUS_VIEW[d.trainingStatus],
            trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
            traineeTypeView: TRAINEE_TYPE[d.traineeType],
            trainingCategoryName: d?.trainingCategoryData?.name,
            trainingSubCategoryName: d?.trainingCategoryData?.subCategory?.find(
              (sub) => sub.id === d?.trainingSubCategory
            )?.name,
            traineeID: d?.traineeData?.srNo || d?.traineeData?.employeeId,
            traineeName: `${capitalizeName(
              d?.traineeData?.firstName + " " + d?.traineeData?.lastName
            )}`,

            traineeDesignation: d?.traineeData?.srNo || d?.traineeData?.employeeId,

            centerCode: batch?.centerCode,
            centerName: batch?.centerName,
            batchId: batch?.batchId,
            duration: batch?.duration,
          })),
          trainingTypeView: TRAINING_TYPE_VIEW[traineeDataObj?.trainingType],
          siteId: traineeDataObj?.siteId,
          siteName: traineeDataObj?.ehsSite?.name,
          from: DDMMYYYYFormat(batch?.trainingDate),
          to: DDMMYYYYFormat(batch?.endDate),
          session: batch?.session,
          schedule: batch?.schedule,

          batchStatusView: TRAINING_BATCHES_STATUS_VIEW[batch?.batchStatus],
        };
      }),
    });
  }
  return {
    status,
    message,
    data: data?.map((batch, index) => {
      const traineeListArray = batch?.traineeList;
      const traineeDataObj = traineeListArray?.length && traineeListArray?.[0];
      return {
        ...batch,
        sid: index + 1,
        batchName: batch?.batchId,
        trainingDateView: DDMMYYYYFormat(batch.trainingDate),
        trainingCategoryName: batch?.trainingCategoryData?.name,
        trainingCategoryId: +batch?.trainingCategory,
        count: batch?.traineeList?.length,
        areaName: batch?.area?.name,
        traineeList: batch?.traineeList?.map((d, i) => ({
          sid: i + 1,
          ...d,
          trainingStatusView: TRAINING_STATUS_VIEW[d.trainingStatus],
          trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
          traineeTypeView: TRAINEE_TYPE[d.traineeType],
          trainingCategoryName: d?.trainingCategoryData?.name,
          trainingSubCategoryName: d?.trainingCategoryData?.subCategory?.find(
            (sub) => sub.id === d?.trainingSubCategory
          )?.name,
          traineeID: d?.traineeData?.srNo || d?.traineeData?.employeeId,
          traineeName: `${capitalizeName(
            d?.traineeData?.firstName + " " + d?.traineeData?.lastName
          )}`,

          traineeDesignation: d?.traineeData?.srNo || d?.traineeData?.employeeId,

          centerCode: batch?.centerCode,
          centerName: batch?.centerName,
          batchId: batch?.batchId,
          duration: batch?.duration,
        })),
        trainingTypeView: TRAINING_TYPE_VIEW[traineeDataObj?.trainingType],
        siteId: traineeDataObj?.siteId,
        siteName: traineeDataObj?.ehsSite?.name,
        from: DDMMYYYYFormat(batch?.trainingDate),
        to: DDMMYYYYFormat(batch?.endDate),
        session: batch?.session,
        schedule: batch?.schedule,

        batchStatusView: TRAINING_BATCHES_STATUS_VIEW[batch?.batchStatus],
      };
    }),
  };
}
export async function getTrainingBatchById(id) {
  let url = "/global-configuration/ehs-module/training-batch/" + id;

  const result = await CallApi(url, "GET");

  const { status, message, data = {} } = result;

  return {
    status,
    message,
    data: {
      ...data,
      trainingDateView: DDMMYYYYHHMMAFormat(data.trainingDate),
      endDate: DDMMYYYYHHMMAFormat(data.endDate),
      trainingCategoryName: data?.trainingCategoryData?.name,
      count: data?.traineeList?.length,
      areaName: data?.area?.name,
      traineeList: data?.traineeList?.map((d, i) => ({
        sid: i + 1,
        ...d,
        trainingStatusView: TRAINING_STATUS_VIEW[d.trainingStatus],
        trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
        traineeTypeView: TRAINEE_TYPE[d.traineeType],
        trainingCategoryName: d?.trainingCategoryData?.name,
        trainingSubCategoryName: d?.trainingCategoryData?.subCategory?.find(
          (sub) => sub.id === d?.trainingSubCategory
        )?.name,
        traineeID: d?.traineeData?.srNo || d?.traineeData?.employeeId,
        traineeName: `${capitalizeName(
          d?.traineeData?.firstName + " " + d?.traineeData?.lastName
        )}`,

        traineeDesignation: d?.traineeData?.srNo || d?.traineeData?.employeeId,

        centerCode: data?.centerCode,
        centerName: data?.centerName,
        batchId: data?.batchId,
        duration: data?.duration,
      })),
    },
  };
}
export const updateAssignersStatus = async (data) => {
  let url = "/global-configuration/ehs-module/update-assigners-status";
  let response = await CallApi(url, "POST", data);
  if (response.status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.BASIC_TRAINING,
      data: [],
    });
    Store.dispatch({
      type: USER_DATA_CONSTANT.NEW_BASIC_TRAINING,
      data: [],
    });
    Store.dispatch({
      type: USER_DATA_CONSTANT.TRAINING_BATCH_DETAILS,
      data: [],
    });
  }
  return response;
};
export const uploadBatchDocument = async (data) => {
  let url = "/global-configuration/ehs-module/update-batch-document";
  return await CallApi(url, "POST", data);
};
export const addTrainingToBatch = async (data) => {
  let url = "/global-configuration/ehs-module/update-training-assigners";
  return await CallApi(url, "POST", data);
};

export async function getTrainingAssignersById(id) {
  let url = "/global-configuration/ehs-module/get-training-assigners-by-id/" + id;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAssignersByAssignedId(id) {
  let url = "/global-configuration/ehs-module/get-assigners-by-assigned-id/" + id;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getTrainingCertificateById(id) {
  let url = "/global-configuration/ehs-module/get-training-certificate-html/" + id;

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateTrainingAssigners(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-training-assigners/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

// export async function updateAssignersStatus(id, data) {
//   try {
//     const response = await RestMethod.PUT(
//       "/global-configuration/ehs-module/update-assigners-status/" + id,
//       data
//     );
//     return response.data;
//   } catch (error) {
//     console.log("error detected while fetching data from api");
//     return null;
//   }
// }

export async function verifyAssignersStatus(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/verify-assigners-status/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function deleteTrainingAssigners(id) {
  try {
    const response = await RestMethod.DELETE(
      "/global-configuration/ehs-module/delete-training-assigners/" + id
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export const createTrainingBatch = async (data) => {
  let url = "/global-configuration/ehs-module/create-training-batch";
  let response = await CallApi(url, "POST", data);
  if (response.status) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.BASIC_TRAINING,
      data: [],
    });
    Store.dispatch({
      type: USER_DATA_CONSTANT.NEW_BASIC_TRAINING,
      data: [],
    });
  }
  return response;
};

export const removeTraineeStatue = async (id) => {
  let url = "/global-configuration/ehs-module/remove-trainee/" + id;
  return await CallApi(url, "PUT");
};

export const absentTraineeStatus = async (id) => {
  let url = "/global-configuration/ehs-module/trainee-absent/" + id;
  return await CallApi(url, "PUT");
};

export const getTrainingById = async (id) => {
  let url = "/global-configuration/ehs-module/get-training-assigners-by-id/" + id;
  return await CallApi(url, "GET");
};

export async function allTrainingAssignersCount() {
  let url = "/global-configuration/ehs-module/all-training-assigners-count";

  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAllTrainingAssignersData(filter) {
  const trainingAllData = Store.getState()?.userManagement?.trainingAllData;
  if (!filter && Array.isArray(trainingAllData.data) && trainingAllData.data.length) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: trainingAllData.data,
        });
      }, 0);
    });
  }
  let url =
    "/global-configuration/ehs-module/all-training-assigners-data" +
    (filter ? `/${filter}` : "");
  const result = await CallApi(url, "GET");
  const { status, message, data = [] } = result;

  let finalData = data?.map((d, index) => {
    return {
      ...d,
      sid: index + 1,
      dueDateView: DDMMYYYYFormat(d?.dueDate),
      dueYear: +moment(d?.dueDate).format("YYYY"),
      traineeName: `${capitalizeName((d?.firstName || "") + " " + (d?.lastName || ""))}`,
      trainingTypeView: TRAINING_TYPE_VIEW[d.trainingType],
      traineeTypeView: TRAINEE_TYPE[d.traineeType],
      traineeId: d?.id,
      traineeIdNo: d?.srNo || d?.employeeId,
      formA: d?.srNo || d?.employeeFormA?.serialNumberOmc || "",
      siteName: d?.ehsSite?.name,
      siteId: d?.ehsSite ? d?.ehsSite?.id : "",
      trainingDesignationName: d?.trainingDesignationData?.name || "",
      lastDoneDate: d?.lastRefresherTrainingDate || d?.basicTrainingCompletionDate,
    };
  });

  if (status && !filter) {
    Store.dispatch({
      type: USER_DATA_CONSTANT.ALL_TRAINING_DATA,
      data: finalData,
    });
  }
  return {
    status,
    message,
    data: finalData,
  };
}
